import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const updateVariant = api(async function updateVariant({
    scenarioId,
    variantId,
    name,
    rateCardId,
    ruleSetIds,
    disabledModifierIds,
}) {
    return mutate(
        gql`
            mutation UpdateVariant(
                $scenarioId: String!
                $variantId: String!
                $name: String
                $rateCardId: String
                $ruleSetIds: [String]
                $disabledModifierIds: [String]
            ) {
                updateVariant(
                    scenarioId: $scenarioId
                    variantId: $variantId
                    name: $name
                    rateCardId: $rateCardId
                    ruleSetIds: $ruleSetIds
                    disabledModifierIds: $disabledModifierIds
                )
            }
        `,
        { scenarioId, variantId, name, rateCardId, ruleSetIds, disabledModifierIds },
        { returns: "updateVariant" }
    )
})
